import { PlatformAccessEnum } from "@dashboard/graphql";
import { IntlShape } from "react-intl";

import { platformMessages } from "./messages";

export const describePlatforms = (
  intl: IntlShape,
  platforms: readonly PlatformAccessEnum[] | null | undefined,
): string => {
  const names = [
    [PlatformAccessEnum.DASHBOARD, platformMessages.dashboard],
    [PlatformAccessEnum.OPS, platformMessages.ops],
    [PlatformAccessEnum.PORTAL, platformMessages.portal],
  ] as const;
  const granted = names
    .filter(([platform]) => platforms?.includes(platform))
    .map(([, message]) => intl.formatMessage(message));

  if (!granted.length) {
    return intl.formatMessage(platformMessages.noPlatform);
  }

  return granted.join(" · ");
};

export const platformsFromFlags = ({
  dashboardAccess,
  opsAccess,
  portalAccess,
}: {
  dashboardAccess: boolean;
  opsAccess: boolean;
  portalAccess?: boolean;
}): PlatformAccessEnum[] => [
  ...(dashboardAccess ? [PlatformAccessEnum.DASHBOARD] : []),
  ...(opsAccess ? [PlatformAccessEnum.OPS] : []),
  ...(portalAccess ? [PlatformAccessEnum.PORTAL] : []),
];
